export const appEnvStrings = ['development', 'staging', 'production'] as const;
export type AppEnv = (typeof appEnvStrings)[number];

export const getAppEnv = (): AppEnv => {
  const mode = (import.meta.env.VITE_MODE || import.meta.env.MODE) as AppEnv | undefined;
  if (!mode || !appEnvStrings.includes(mode)) {
    return 'production';
  }
  return mode;
};

export const apiBaseUrl = () => {
  const baseUrl = import.meta.env?.VITE_API_BASE_URL;
  if (baseUrl === undefined) {
    throw new Error('API Base URL not configured');
  }
  return baseUrl;
};

export default null;
